export interface MaterialDeliveredType {
    id: number;
    estimation_id: number | null;
    delivered_quantity: number | null;
    date: string | null;
}

// to single object maping
export const mapMaterialDeliveredType = (data: any): MaterialDeliveredType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialDeliveredType: MaterialDeliveredType = {
        id: data.id,
        estimation_id: data.estimation_id || null,
        delivered_quantity: data.delivered_quantity || null,
        date: data.date || null,
    }

    return materialDeliveredType;
}

// maping list objects
export const mapMaterialDeliveredTypes = (data: any[]): MaterialDeliveredType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    
    return data.map(mapMaterialDeliveredType);
}